export default __webpack_public_path__ + "static/media/640_business06-en-mobile.7119e574.png";